namespace $ {
	
	$mol_test_mocks.push( $=> {
		class $giper_baza_land_mock extends $.$giper_baza_land {
			
			sync() {
				return this
			}
			
		}
		$.$giper_baza_land = $giper_baza_land_mock
	} )
	
	$mol_test({
		
		async 'Give rights'( $ ) {
			
			const auth0 = await $.$giper_baza_auth.grab()
			const auth1 = await $.$giper_baza_auth.grab()
			const auth2 = await $.$giper_baza_auth.grab()
			
			const land0 = $giper_baza_land.make({ $, auth: ()=> auth0 })
			const land1 = $giper_baza_land.make({ $, link: ()=> land0.link(), auth: ()=> auth1 })
			
			$mol_assert_equal( land0.lord_rank( land0.link() ), $giper_baza_rank_rule )
			$mol_assert_equal( land0.lord_rank( auth1.pass().lord() ), $giper_baza_rank_read )
			
			land1.give( auth2.pass(), $giper_baza_rank_post( 'just' ) )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_read )
			
			land0.give( auth1.pass(), $giper_baza_rank_read )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_read )
			
			land0.give( auth1.pass(), $giper_baza_rank_read )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_read )
			
			land0.give( auth1.pass(), $giper_baza_rank_post( 'just' ) )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_post( 'just' ) )
			
			land0.give( auth1.pass(), $giper_baza_rank_pull( 'just' ) )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_pull( 'just' ) )
			
			land0.give( auth1.pass(), $giper_baza_rank_rule )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_rule )
			
			land0.give( auth1.pass(), $giper_baza_rank_post( 'just' ) )
			$mol_assert_equal( land0.pass_rank( auth1.pass() ), $giper_baza_rank_post( 'just' ) )
			
			await $mol_wire_async( land1 ).units_steal( land0 )
			$mol_assert_equal( land1.pass_rank( auth1.pass() ), $giper_baza_rank_post( 'just' ) )
			land1.give( auth2.pass(), $giper_baza_rank_post( 'just' ) )
			
		},
		
		async 'Post Data and pick Delta'( $ ) {
			
			const auth1 = $.$giper_baza_auth.grab()
			const auth2 = $.$giper_baza_auth.grab()
			
			const land1 = $giper_baza_land.make({ $, auth: ()=> auth1 })
			const land2 = $giper_baza_land.make({ $, link: ()=> land1.link(), auth: ()=> auth2 })
			
			$mol_assert_equal( await $mol_wire_async( land1 ).diff_units(), [] )
			
			land1.post( $giper_baza_link.hole, $giper_baza_link.hole, new $giper_baza_link( 'AA111111' ), new Uint8Array([ 1 ]) )
			$mol_assert_equal( ( await $mol_wire_async( land1 ).diff_units() ).length, 4 )
			
			const face = land1.faces.clone()
			
			land1.post( new $giper_baza_link( 'AA111111' ), $giper_baza_link.hole, new $giper_baza_link( 'AA222222' ), new Uint8Array([ 2 ]) )
			$mol_assert_equal( ( await $mol_wire_async( land1 ).diff_units() ).length, 5 )
			$mol_assert_equal( ( await $mol_wire_async( land1 ).diff_units( face ) ).length, 2 )
			
			await $mol_wire_async( land2 ).units_steal( land1 )
			
			land2.post( new $giper_baza_link( 'AA222222' ), $giper_baza_link.hole, new $giper_baza_link( 'AA333333' ), new Uint8Array([ 3 ]) )
			$mol_assert_equal( ( await $mol_wire_async( land2 ).diff_units() ).length, 5 )
			$mol_assert_equal( ( await $mol_wire_async( land2 ).diff_units( face ) ).length, 2 )
			
			land1.give( auth2.pass(), $giper_baza_rank_post( 'just' ) )
			await $mol_wire_async( land2 ).units_steal( land1 )
			land2.post( new $giper_baza_link( 'AA222222' ), $giper_baza_link.hole, new $giper_baza_link( 'AA333333' ), new Uint8Array([ 5 ]) )
			$mol_assert_equal( ( await $mol_wire_async( land2 ).diff_units() ).length, 9 )
			$mol_assert_equal( ( await $mol_wire_async( land2 ).diff_units( face ) ).length, 6 )
			
			land1.give( auth2.pass(), $giper_baza_rank_read )
			await $mol_wire_async( land2 ).units_steal( land1 )
			$mol_assert_equal( ( await $mol_wire_async( land2 ).diff_units() ).length, 7 )
			
		},
		
		async 'Land encryption'( $ ) {
			
			const land = $mol_wire_async( $giper_baza_land.make({ $ }) )
			$mol_assert_equal( await land.encrypted(), false )
			
			await land.encrypted( true )
			$mol_assert_equal( await land.encrypted(), true )
			
			const material = await land.post( $giper_baza_link.hole, $giper_baza_link.hole, null, new Uint8Array([ 1, 2, 3 ]) )
			
			$mol_assert_equal( ( await land.sand_encode( material ) ).data().length, 16 )
			$mol_assert_equal( await land.sand_decode( material ), new Uint8Array([ 1, 2, 3 ]) )
			$mol_assert_equal( ( await land.sand_ordered({ head: $giper_baza_link.hole, peer: $giper_baza_link.hole }) ).length, 1 )
			
			const tombstone = await land.post( $giper_baza_link.hole, $giper_baza_link.hole, material.self(), null )
			
			$mol_assert_equal( ( await land.sand_encode( tombstone ) ).data().length, 1 )
			$mol_assert_equal( await land.sand_decode( tombstone ), null )
			$mol_assert_equal( ( await land.sand_ordered({ head: $giper_baza_link.hole, peer: $giper_baza_link.hole }) ).length, 1 )
			
		},
		
		'Land fork & merge': $mol_wire_async( ( $: $ )=> {
			
			const home = $.$giper_baza_glob.home().land()
			const left = home.fork()
			
			home.Data( $giper_baza_list ).items_vary([ 'foo', 'xxx' ])
			$mol_assert_equal( home.Data( $giper_baza_list ).items_vary(), [ 'foo', 'xxx' ] )
			$mol_assert_equal( left.Data( $giper_baza_list ).items_vary(), [ 'foo', 'xxx' ] )
			
			left.faces.sync( home.faces )
			left.Data( $giper_baza_list ).items_vary([ 'foo', 'yyy' ])
			$mol_assert_equal( left.Data( $giper_baza_list ).items_vary(), [ 'foo', 'yyy' ] )
			
			const right = home.fork()
			right.faces.sync( left.faces )
			right.Data( $giper_baza_list ).items_vary([ 'foo', 'zzz' ])
			$mol_assert_equal( right.Data( $giper_baza_list ).items_vary(), [ 'foo', 'zzz' ] )
			
			const both = home.fork()
			$mol_assert_equal( both.Data( $giper_baza_list ).items_vary(), [ 'foo', 'xxx' ] )
			
			both.Tine().items_vary([ right.link() ])
			$mol_assert_equal( both.Data( $giper_baza_list ).items_vary(), [ 'foo', 'zzz' ] )
			
			both.Tine().items_vary([ left.link() ])
			$mol_assert_equal( both.Data( $giper_baza_list ).items_vary(), [ 'foo', 'yyy' ] )
			
			both.Tine().items_vary([ right.link(), left.link() ])
			$mol_assert_equal( both.Data( $giper_baza_list ).items_vary(), [ 'foo', 'yyy' ] )
			
			both.Tine().items_vary([ left.link(), right.link() ])
			$mol_assert_equal( both.Data( $giper_baza_list ).items_vary(), [ 'foo', 'zzz' ] )
			
		} ),
		
		'Inner Links are relative to forked Land': $mol_wire_async( ( $: $ )=> {
			
			const Alice = $.$giper_baza_glob.home().land()
			const Bella = Alice.fork()
			
			const alice_val = Alice.Pawn( $giper_baza_atom_text ).Head( new $giper_baza_link( 'qwertyui' ) )
			const bella_val = Bella.Pawn( $giper_baza_atom_text ).Head( new $giper_baza_link( 'qwertyui' ) )
			
			alice_val.val( 'Alice' )
			bella_val.val( 'Bella' )
			
			const alice_link = Alice.Pawn( $giper_baza_atom_link ).Head( new $giper_baza_link( 'asdfghjk' ) )
			const bella_link = Bella.Pawn( $giper_baza_atom_link ).Head( new $giper_baza_link( 'asdfghjk' ) )
			
			alice_link.val( alice_val.link() )
			$mol_assert_equal( alice_link.val(), alice_val.link() )
			$mol_assert_unique( alice_link.val(), bella_link.val() )
			$mol_assert_equal( bella_link.val(), bella_val.link() )
			
		} ),
		
		async 'Land Area inherits rights'( $ ) {
			
			const area = await $mol_wire_async( ()=> {
				const base = $.$giper_baza_glob.land_grab([[ null, $giper_baza_rank_post( 'just' ) ]])
				base.units_saving()
				return base.area_make()
		 	} )()
			
			$mol_assert_equal( area.pass_rank( area.auth().pass() ), $giper_baza_rank_rule )
			$mol_assert_equal( area.lord_rank( $giper_baza_link.hole ), $giper_baza_rank_post( 'just' ) )
			
		},
		
		// async 'Merge text changes'() {
			
		// 	const base = new $giper_baza_land( 1n, 1 )
		// 	base.chief.as( $hyoo_crowd_text ).str( 'Hello World and fun!' )
			
		// 	const left = base.fork( await $hyoo_crowd_peer.generate() )
		// 	const right = base.fork( await $hyoo_crowd_peer.generate() )
		// 	right.clock_data.tick( right.peer().id )
			
		// 	left.chief.as( $hyoo_crowd_text ).str( 'Hello Alice and fun!' )
		// 	right.chief.as( $hyoo_crowd_text ).str( 'Bye World and fun!' )
			
		// 	const left_delta = left.delta()
		// 	const right_delta = right.delta()
			
		// 	left.apply( right_delta )
		// 	right.apply( left_delta )

		// 	$mol_assert_equal(
		// 		left.chief.as( $hyoo_crowd_text ).str(),
		// 		right.chief.as( $hyoo_crowd_text ).str(),
		// 		'Bye Alice and fun!',
		// 	)

		// },
		
		// async 'Write into token'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'foobar' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'xyz', 3 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'fooxyzbar' ] )
			
		// },
		
		// async 'Write into token with split'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'foobar' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'XYZ', 2, 4 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'fo', 'XYZar' ] )
			
		// },
		
		// async 'Write over few tokens'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'xxx foo bar yyy' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'X Y Z', 6, 9 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'xxx', ' fo', 'X', ' Y', ' Zar', ' yyy' ] )
			
		// },
		
		// async 'Write whole token'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'xxxFoo yyy' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'bar', 3, 7 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'xxxbaryyy' ] )
			
		// },
		
		// async 'Write whole text'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'foo bar' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'xxx', 0, 7 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'xxx' ] )
			
		// },
		
		// async 'Write at the end'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'foo' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'bar' )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'foobar' ] )
			
		// },
		
		// async 'Write between tokens'() {
			
		// 	const store = new $giper_baza_land( 1n, 1 )
		// 	store.chief.as( $hyoo_crowd_text ).str( 'foo bar' )
		// 	store.chief.as( $hyoo_crowd_text ).write( 'xxx', 4 )
			
		// 	$mol_assert_equal( store.chief.as( $hyoo_crowd_list ).list(), [ 'foo', ' xxxbar' ] )
			
		// },

	})
}
